

// The properties that we copy into a mirrored div.
// Note that some browsers, such as Firefox,
// do not concatenate properties, i.e. padding-top, bottom etc. -> padding,
// so we have to do every single property specifically.
const PROPS_TEXT = [
    'fontStyle',
    'fontVariant',
    'fontWeight',
    'fontStretch',
    'fontSize',
    'lineHeight',
    'fontFamily',
    'textAlign',
    'textTransform',
    'textIndent',
    'textDecoration', 
    'letterSpacing',
    'wordSpacing'
];
const PROPERTIES = [
    'boxSizing',
    'width', // on Chrome and IE, exclude the scrollbar, so the mirror div wraps exactly as the textarea does
    'height',
    'overflowX',
    'overflowY', // copy the scrollbar for IE

    'borderTopWidth',
    'borderRightWidth',
    'borderBottomWidth',
    'borderLeftWidth',

    'paddingTop',
    'paddingRight',
    'paddingBottom',
    'paddingLeft',
    ...PROPS_TEXT
];

var isFirefox = !(window.mozInnerScreenX == null);

const get_or_create_mirror_div = function(mirrorDivId) {
    let mirrorDiv = document.getElementById(mirrorDivId);
    
    if(mirrorDiv) {
        return mirrorDiv;
    }
    
    mirrorDiv = document.createElement('div');
    mirrorDiv.id = mirrorDivId;
    document.body.appendChild(mirrorDiv);

    return mirrorDiv;
};


const copyStyle = function(from, to, _props) {
    let props = _props === undefined ? PROPERTIES : _props;
    let computed = getComputedStyle(from);
    
    // transfer the element's properties to the div
    props.forEach(function(prop) {
        to.style[prop] = computed[prop];
    });
};

const getElementForCorrection = function(element, start, end, instance, corrections_css_class) {

   let mirrorDivId = "m-" + instance;
    
    // mirrored div
    let mirrorDiv = get_or_create_mirror_div(mirrorDivId);
    let style = mirrorDiv.style;
    let computed = getComputedStyle(element);

    // default textarea styles
    style.whiteSpace = 'pre-wrap';
	
    if (element.nodeName !== 'INPUT')
        style.wordWrap = 'break-word'; // only for textarea-s
	
    // position off-screen
    style.position = 'absolute'; // required to return coordinates properly
    style.top = element.offsetTop + parseInt(computed.borderTopWidth) + 'px';
    style.left = "400px";
    style.visibility = 'hidden'; // not 'display: none' because we want rendering

    copyStyle(element, mirrorDiv);

    if (isFirefox) {
        style.width = parseInt(computed.width) - 2 + 'px'; // Firefox adds 2 pixels to the padding - https://bugzilla.mozilla.org/show_bug.cgi?id=753662
        // Firefox lies about the overflow property for textareas: https://bugzilla.mozilla.org/show_bug.cgi?id=984275
        if (element.scrollHeight > parseInt(computed.height))
            style.overflowY = 'scroll';
    } else {
        style.overflow = 'hidden'; // for Chrome to not render a scrollbar; IE keeps overflowY = 'scroll'
    }

    mirrorDiv.textContent = element.value.substring(0, start);
    
    // the second special handling for input type="text" vs textarea: //
	// spaces need to be replaced with non-breaking spaces - http://stackoverflow.com/a/13402035/1269037
    if (element.nodeName === 'INPUT')
        mirrorDiv.textContent = mirrorDiv.textContent.replace(/\s/g, "\u00a0");

    var span = document.createElement('span');
    // Wrapping must be replicated *exactly*, including when a long word gets
    // onto the next line, with whitespace at the end of the line before (#7).
    // The  *only* reliable way to do that is to copy the *entire* rest of the
    // textarea's content into the <span> created at the caret position.
    // for inputs, just '.' would be enough, but why bother?
    span.textContent = element.value.substring(start) || '.'; // || because a completely empty faux span doesn't render at all
    span.style.backgroundColor = "lightgrey";
    mirrorDiv.appendChild(span);

    var coordinates = {
        top: span.offsetTop + parseInt(computed['borderTopWidth']),
        left: span.offsetLeft + parseInt(computed['borderLeftWidth'])
    };


    var rect = document.createElement('div');
    rect.className = corrections_css_class;
    copyStyle(element, rect, PROPS_TEXT);
    
    rect.style.position = 'absolute'; // put it in the right space
    rect.style.cursor = 'pointer'; // make it clear they can click
    
    // set the style for the type of correction
    rect.style.borderBottom = 'solid 2px #ca2323';
    rect.style.backgroundColor = '#ffeaee';
    rect.style.paddingLeft = "2px";
    rect.style.paddingRight = "2px";
    rect.style.borderRadius = "1px";
    rect.style.borderTopLeftRadius = "3px";
    rect.style.borderTopRightRadius = "3px";


    rect.innerHTML = element.value.substr(start, end); // FIXME: should be cleaned up
	
	var bodyRect = document.body.getBoundingClientRect(),
		elemRect = element.getBoundingClientRect(),
		offsetTop   = elemRect.top - bodyRect.top,
		offsetLeft  = elemRect.left - bodyRect.left;

	rect.style.top = offsetTop - element.scrollTop + coordinates.top - 5  + 'px';
    rect.style.left = offsetLeft - element.scrollLeft + coordinates.left + 'px';
	
    document.body.appendChild(rect);
    
    return rect;
};

export { getElementForCorrection }; 
